import { render, staticRenderFns } from "./CompanyItemView.vue?vue&type=template&id=0dc5a417"
import script from "./CompanyItemView.vue?vue&type=script&lang=js"
export * from "./CompanyItemView.vue?vue&type=script&lang=js"
import style0 from "./CompanyItemView.vue?vue&type=style&index=0&id=0dc5a417&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports